module.exports = __webpack_public_path__ + "static/media/img-destaque-home.d03a35d9.jpg";